import { isEqual, pick } from 'lodash';

export function push(state, route) {
   const reduced = pick(route, ['name', 'params', 'query', 'meta']);
   if (reduced.name === 'landing') {
      return;
   }
   if (!state.history.length || !isEqual(state.history[0], reduced)) {
      if (state.ignoreNext) {
         state.ignoreNext = false;
         return;
      }
      state.history.unshift(reduced);
   }
}

export function ignoreNext(state) {
   state.ignoreNext = true;
}

export function pop(state) {
   state.history.shift();
}

export function reset(state) {
   state.history = [];
}
